/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerievideoSeriesSerieidQueryResponse,
  GetApiV1SerievideoSeriesSerieidPathParams,
  GetApiV1SerievideoSeriesSerieidQueryParams,
  GetApiV1SerievideoSeriesSerieid401,
  GetApiV1SerievideoSeriesSerieid404,
  GetApiV1SerievideoSeriesSerieid500,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoSeriesSerieid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerievideoSeriesSerieid } from "../../clients/serieVideoRegistroController/getApiV1SerievideoSeriesSerieid.ts";

export const getApiV1SerievideoSeriesSerieidQueryKey = (
  serieId: GetApiV1SerievideoSeriesSerieidPathParams["serieId"],
  params?: GetApiV1SerievideoSeriesSerieidQueryParams,
) =>
  [
    { url: "/api/v1/serievideo/series/:serieId", params: { serieId: serieId } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerievideoSeriesSerieidQueryKey = ReturnType<
  typeof getApiV1SerievideoSeriesSerieidQueryKey
>;

export function getApiV1SerievideoSeriesSerieidQueryOptions(
  serieId: GetApiV1SerievideoSeriesSerieidPathParams["serieId"],
  params?: GetApiV1SerievideoSeriesSerieidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerievideoSeriesSerieidQueryKey(serieId, params);
  return queryOptions<
    GetApiV1SerievideoSeriesSerieidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoSeriesSerieid401
      | GetApiV1SerievideoSeriesSerieid404
      | GetApiV1SerievideoSeriesSerieid500
    >,
    GetApiV1SerievideoSeriesSerieidQueryResponse,
    typeof queryKey
  >({
    enabled: !!serieId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerievideoSeriesSerieid(serieId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma lista paginada de vídeos de uma série (informe o serieId na rota). Filtra por título. **(Requer Authorization para autenticação)**
 * @summary Listar vídeos da série (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/series/:serieId}
 */
export function useGetApiV1SerievideoSeriesSerieid<
  TData = GetApiV1SerievideoSeriesSerieidQueryResponse,
  TQueryData = GetApiV1SerievideoSeriesSerieidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerievideoSeriesSerieidQueryKey,
>(
  serieId: GetApiV1SerievideoSeriesSerieidPathParams["serieId"],
  params?: GetApiV1SerievideoSeriesSerieidQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerievideoSeriesSerieidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerievideoSeriesSerieid401
          | GetApiV1SerievideoSeriesSerieid404
          | GetApiV1SerievideoSeriesSerieid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerievideoSeriesSerieidQueryKey(serieId, params);

  const query = useQuery(
    {
      ...getApiV1SerievideoSeriesSerieidQueryOptions(serieId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerievideoSeriesSerieid401
      | GetApiV1SerievideoSeriesSerieid404
      | GetApiV1SerievideoSeriesSerieid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
